import { Box, Typography } from "@mui/material";
import React from "react";
import Dropzone from "react-dropzone";
import GlobalButton from "../CustomButton";

const DropMedia = ({ acceptedFiles, multipleee, handleChangeImage }) => {
  return (
    <Dropzone
      accept={
        acceptedFiles || {
          "image/jpeg": [],
          "image/png": [],
        }
      }
      multiple={multipleee || false}
      onDrop={handleChangeImage}
    >
      {({ getRootProps, getInputProps }) => (
        <div
          {...getRootProps()}
          style={{
            background: "#f9f9f9",
            border: "1px dashed black",
            cursor: "pointer",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <input {...getInputProps()} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography sx={{ fontWeight: "700", color: "black" }}>
                Drag and drop your images here
              </Typography>
              <Typography
                sx={{ color: "#a2a2a2", fontSize: "13px", fontWeight: "500" }}
              >
                Or click to browse
              </Typography>
            </Box>

            <GlobalButton
              variant={"contained"}
              btnText={"Choose a file"}
              styleProps={{
                background: "#fff",
                color: "black",
                width: "auto",
                padding: "5px 15px",
                fontSize: "14px",
                fontWeight: "600",
              }}
              hoverProperties={{
                background: "#fff",
              }}
            />
          </Box>
        </div>
      )}
    </Dropzone>
  );
};

export default DropMedia;
